import axiosInstance from "./AxiosAPICaller";
import { GroupedImagesResponse } from "../Interfaces/IBubbleImagesResponse";
import { IBubble } from "../Interfaces/IBubbles";

export const fetchBubbles = async (): Promise<IBubble[]> => {
  try {
      const response = await axiosInstance.get<{ data: { id: number; attributes: any }[] }>("/bulles");

      if (!Array.isArray(response.data.data)) {
          throw new Error("La réponse de l'API n'est pas un tableau.");
      }

      // Map et structure les données
      const extractedData = response.data.data.map(item => ({
          Id: item.id,
          Position: item.attributes.Position,
          Title: item.attributes.Titre,
          Description: item.attributes.Description,
          UsefullLinks: item.attributes.liens_utiles || null,
          IsProtectedByMail: item.attributes.Authentification_Mail || false,
          ImagesGroup: item.attributes.groupes_d_images || null,
          ContactsGroup: Array.isArray(item.attributes.groupes_de_contacts)
              ? item.attributes.groupes_de_contacts.map((contacts: { id: number }) => contacts.id)
              : null,
          LinksGroup: Array.isArray(item.attributes.groupe_de_liens)
              ? item.attributes.groupe_de_liens.map((Liens: { id: number }) => Liens.id)
              : null
      }));

      // Trie par position
      return extractedData.sort((a, b) => a.Position - b.Position);
  } catch (error) {
      console.error("Erreur lors de la récupération des bulles :", error);
      throw error;
  }
};

export const fetchImagesCarouselFromOneBubble = async (id: number): Promise<GroupedImagesResponse> => {
    try {
        const response = await axiosInstance.get<GroupedImagesResponse>(`/groupes-d-images/${id}?populate[images][fields][0]=url`);
        return response.data;
      } catch (error) {
        console.error(`Erreur lors de la récupération du groupe d'images avec l'ID ${id} :`, error);
        throw new Error("Failed to fetch images");
      }
  };